export default __webpack_public_path__ + "static/media/earnings.a6bff3df.svg";